import { AppealsRoute, ClaimsPrepayRoute } from 'constants/routes';

export const CLAIMS_SEARCH_DEFAULT_COLUMNS = new Set([
  'claimId',
  'clientClaimId',
  'alternateClaimId',
  'networkName',
  'startDOS',
  'providerTIN',
  'providerName',
  'subscriberId',
  'subscriberName',
  'patientDOB',
  'patientName',
  'charges',
  'savings',
  'serviceLabel',
  'divisionName',
  'servicingNPI',
  'billingNPI',
]);

export const CLAIMS_SEARCH_ALL_COLUMNS = new Set([
  'claimId',
  'clientClaimId',
  'alternateClaimId',
  'networkName',
  'startDOS',
  'providerTIN',
  'providerName',
  'subscriberId',
  'subscriberName',
  'patientDOB',
  'patientName',
  'charges',
  'savings',
  'serviceLabel',
  'divisionName',
  'servicingNPI',
  'billingNPI',
  'manuallyEnteredCheck'
]);


export const SEARCH_RESULT_GRID_COLUMNS = new Set([
  {
    dataName: 'providerName',
    text: 'Provider Name',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'facilityName',
    text: 'Facility',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'tin',
    text: 'TIN',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'providerAddress',
    text: 'Address',
    sortable: true,
    isSorted: 0,
  },
]);

export const SINGLE_SELECT_GROUP_ITEMS = {
  items: [
    {
      text: 'Claims',
      items: [
        {
          text: 'Prepay',
          path: ClaimsPrepayRoute,
        },
        // {
        //   text: 'Paid',
        //   path: ClaimsPaidRoute,
        // },
      ],
    },
    {
      text: 'Appeals',
      items: [
        {
          text: 'All',
          path: AppealsRoute,          
        },
      ],
    },
  ],
};

export const SINGLE_SELECT_GROUP_APPEAL_QUEUE_ITEMS = [
  {
    text: 'All',
    path: AppealsRoute,
    count: null,
  },
  {
    text: 'New',
    path: AppealsRoute,
    count: 0,
  },
  {
    text: 'Open',
    path: AppealsRoute,
    count: 0,
  },
  {
    text: 'Hold',
    path: AppealsRoute,
    count: 0,
  },
  {
    text: 'Reopen',
    path: AppealsRoute,
    count: 0,
  },
  {
    text: 'Pend',
    path: AppealsRoute,
    count: 0,
  },
];

export const SEARCH_GRID_TITLE = 'Search Results';
export const VALIDATION_ERROR_MSG = 'Invalid search text, Allowed special characters: - _ .';
export const SEARCH_INPUT_PLACEHOLDER_CLAIM_ID = 'Search by Claim ID';
export const SEARCH_INPUT_PLACEHOLDER_CASE_ID = 'Search by Case ID';
export const GET_SEARCH_RESULTS_SUCCESS =
  'src/containers/Claims/SearchSection/GET_PREPAY_SEARCH_RESULTS_SUCCESS';
export const RESET_SEARCH_RESULTS = 'src/containers/Claims/SearchSection/RESET_SEARCH_RESULTS';
export const SET_PREPAY_SEARCH_CLAIMID =
  'src/containers/Claims/SearchSection/SET_PREPAY_SEARCH_CLAIMID';
export const SET_LOADING_INDICATOR = 'src/containers/Claims/SearchSection/SET_LOADING_INDICATOR';
export const SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_CLIENTS =
  'src/containers/Claims/SearchSection/SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_CLIENTS';
export const SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES =
  'src/containers/Claims/SearchSection/SET_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES';
export const SET_CREATE_CLAIM_LOOKUP =
  'src/containers/Claims/SearchSection/SET_CREATE_CLAIM_LOOKUP';
export const TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES_LOADING =
  'src/containers/Claims/SearchSection/TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_SERVICES_LOADING';
export const TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_LOADING =
  'src/containers/Claims/SearchSection/TOGGLE_CLAIMS_ADVANCED_SEARCH_LOOPKUP_LOADING';
export const TOGGLE_EXPORT_CLAIMS_ADVANCED_SEARCH_LOADING =
  'src/containers/Claims/SearchSection/TOGGLE_EXPORT_CLAIMS_ADVANCED_SEARCH_LOADING';
export const TOGGLE_CREATE_CLAIM_LOOPKUP_LOADING =
  'src/containers/Claims/SearchSection/TOGGLE_CREATE_CLAIM_LOOPKUP_LOADING';
export const SET_CREATE_CLAIM_CLIENT_NETWORKS =
  'src/containers/Claims/SearchSection/SET_CREATE_CLAIM_CLIENT_NETWORKS';
export const SET_CREATE_CLAIM_CLIENT_SERVICES =
  'src/containers/Claims/SearchSection/SET_CREATE_CLAIM_CLIENT_SERVICES';
export const SET_CLAIMS_GRID_COLUMN_CONFIG = 'src/containers/Claims/SearchSection/SET_CLAIMS_GRID_COLUMN_CONFIG';

export const CLAIM_LINE_DETAILS_GRID_COLUMNS = (isRevCodeRequired, isCptHcpcRequired) =>
  new Set([
    {
      dataName: 'lineNum',
      text: '',
      sortable: true,
      isSorted: 0,
      headerWidth: 5,
      isHeaderTruncated: true,
      align: 'left',
    },
    {
      dataName: 'beginDOS',
      text: 'Begin DOS*',
      sortable: true,
      isSorted: 0,
      headerWidth: 140,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'endDOS',
      text: 'End DOS*',
      sortable: true,
      isSorted: 0,
      headerWidth: 140,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'pos',
      text: 'POS*',
      sortable: true,
      isSorted: 0,
      headerWidth: 30,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'revCode',
      text: `Rev Code${isRevCodeRequired ? '*' : ''}`,
      sortable: true,
      isSorted: 0,
      headerWidth: 80,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'cptHcpc',
      text: `CPT / HCPC${isCptHcpcRequired ? '*' : ''}`,
      sortable: true,
      isSorted: 0,
      headerWidth: 80,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'mod1',
      text: 'Mod 1',
      sortable: true,
      isSorted: 0,
      headerWidth: 40,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'mod2',
      text: 'Mod 2',
      sortable: true,
      isSorted: 0,
      headerWidth: 40,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'mod3',
      text: 'Mod 3',
      sortable: true,
      isSorted: 0,
      headerWidth: 40,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'mod4',
      text: 'Mod 4',
      sortable: true,
      isSorted: 0,
      headerWidth: 40,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'units',
      text: 'Unit*',
      sortable: true,
      isSorted: 0,
      headerWidth: 45,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'billedCharged',
      text: 'Bill Charges*',
      sortable: true,
      isSorted: 0,
      headerWidth: 90,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'allowed',
      text: 'Allowed*',
      sortable: true,
      isSorted: 0,
      headerWidth: 90,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'savings',
      text: 'Savings*',
      sortable: true,
      isSorted: 0,
      headerWidth: 90,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'recAmount',
      text: 'Rec. Amount*',
      sortable: true,
      isSorted: 0,
      headerWidth: 90,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    {
      dataName: 'netName',
      text: 'Network Name',
      sortable: true,
      isSorted: 0,
      headerWidth: 150,
      isHeaderTruncated: true,
      cellType: 'custom',
    },
    // {
    //   dataName: 'reason',
    //   text: 'Reason',
    //   sortable: true,
    //   isSorted: 0,
    //   headerWidth: 120,
    //   isHeaderTruncated: true,
    //   cellType: 'custom',
    // },
    {
      dataName: 'trashIcon',
      text: '',
      sortable: true,
      isSorted: 0,
      cellType: 'custom',
      isHeaderTruncated: true,
      headerWidth: 50,
    },
  ]);
